import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { deleteRow, listCollection, saveRow, type Row } from '../../lib/db';
import { sortByOrder } from '../../lib/order';
import { OrderInput } from '../../components/OrderInput';
import { useToast } from '../../components/Toast';

export function TeamList() {
  const [rows, setRows] = useState<Row[]>([]);
  const [loading, setLoading] = useState(true);
  const { notify } = useToast();

  const load = () =>
    listCollection('teamMembers', 'createdAt').then((r) => {
      setRows(sortByOrder(r));
      setLoading(false);
    });
  useEffect(() => {
    void load();
  }, []);

  const remove = async (id: string) => {
    if (!confirm('Delete this team member?')) return;
    await deleteRow('teamMembers', id);
    notify('success', 'Deleted.');
    void load();
  };

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3 className="fw-bold m-0">Team members</h3>
        <Link to="/team/new" className="btn btn-success btn-sm">
          New member
        </Link>
      </div>
      {loading ? (
        <p className="text-muted">Loading…</p>
      ) : (
        <table className="table table-hover">
          <thead>
            <tr>
              <th>Order</th>
              <th>Name (BG)</th>
              <th>Position (BG)</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => {
              const fn = (r.firstName ?? {}) as { bg?: string };
              const ln = (r.lastName ?? {}) as { bg?: string };
              const pos = (r.position ?? {}) as { bg?: string };
              return (
                <tr key={r.id}>
                  <td>
                    <OrderInput
                      value={typeof r.order === 'number' ? r.order : undefined}
                      onSave={async (n) => {
                        await saveRow('teamMembers', r.id, { order: n });
                        void load();
                      }}
                    />
                  </td>
                  <td>
                    {fn.bg} {ln.bg}
                  </td>
                  <td>{pos.bg}</td>
                  <td className="text-end">
                    <Link to={`/team/${r.id}`} className="btn btn-sm btn-outline-secondary me-2">
                      Edit
                    </Link>
                    <button className="btn btn-sm btn-outline-danger" onClick={() => remove(r.id)}>
                      Delete
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </>
  );
}
